import React, { useState, cloneElement, ReactElement } from 'react';
import Menu, { MenuProps } from '@mui/material/Menu';
import MenuItem, { MenuItemProps } from '@mui/material/MenuItem';

export type PopupMenuItem = Omit<MenuItemProps, 'onClick'> & {
  label: React.ReactNode;
  onClick: (row?: any) => void;
  showFn?: (row: any) => boolean;
};

export interface PopupMenuProps {
  items: PopupMenuItem[];
  row?: any;
  children?: ReactElement<any>;
  menuProps?: Partial<MenuProps>;
}

const PopupMenu: React.FC<PopupMenuProps> = ({ items, row, children, menuProps }) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const visibleItems = items.filter(item => !item.showFn || (row && item.showFn(row)));

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  if (visibleItems.length === 0) return null;

  const buttonMenuProps = children
    ? cloneElement(children, {
        'onClick': handleClick,
        'aria-controls': open ? 'popup-menu' : undefined,
        'aria-haspopup': true,
        'aria-expanded': open ? true : undefined,
      })
    : null;

  return (
    <>
      {buttonMenuProps}
      <Menu id='popup-menu' anchorEl={anchorEl} open={open} onClose={handleClose} {...menuProps}>
        {visibleItems.map((item, index) => {
          const { onClick, label, showFn, ...menuProps } = item;
          return (
            <MenuItem
              key={index}
              onClick={() => {
                onClick(row);
                handleClose();
              }}
              {...menuProps}>
              {label}
            </MenuItem>
          );
        })}
      </Menu>
    </>
  );
};

export default PopupMenu;
